/* eslint-disable max-lines */
import { createGlobalStyle } from "styled-components";

export const PAYMENT_SUCCESS_ONE_LOGO_STYLE = {
    DEFAULT: {
        successAnimationOneStyle: {
            width: 58,
            height: 20,
        },
        paymentScreenOneStyle: {
            width: 38,
            height: 13.5,
        },
    },
};

export const USER_STATUS_SUPER = "SUPER";

export const TIP_CHARGE = "restaurantTippingCharges";
export const TIP_AMOUNT_CONFIGS = {
    MAX_DEFAULT_TIP: 500,
    MIN_DEFAULT_TIP: 1,
};

export const PAYMENT_SUCCESS = "PaymentSuccess";

export const BILL_ELEMENT_ENTRIES = {
    GST_CONVENIENCE_FEE: "GST on convenience fee",
    TO_PAY: "To Pay",
    TOTAL_BILL_AMOUNT: "Total bill amount",
    ADVANCE_AMOUNT: "Cover charge redeemed",
    DISCOUNT_TYPE_FLAT: "FLAT",
    INR_CURRENCY_SYMBOL: "₹",
    MINUS_SYMBOL: "-",
    CONVENIENCE_FEE_TYPE: "convenienceFee",
    TOTAL_BILL_AMOUNT_ID: "billAmount",
    PLAN_AMOUNT_ID: "planAmount",
    BILL_TO_PAY_ID: "billToPay",
    ADD_TIP_ID: "addTip",
    ADD_TIP_CART_ID: "addCartTip",
    ADD_TIP_MODAL: "tipModal",
    DISCOUNT_ID: "discount_",
    AMOUNT_PAID: "Amount Paid",
    ADVANCE_AMOUNT_ID: "advance_",
    TOTAL_PAID: "Total Paid",
    PRE_BOOK_TOTAL_BILL_AMOUNT: "Cover charges for {0} ",
    AMOUNT_TO_PAY: "Amount to pay",
    DINE_CASH: "DineCash applied",
    DINE_CASH_ID: "dineCash",
    GST_ID: "gst_id",
    TOTAL_BILL: "Total Bill",
    ADVANCE_PAID: "Advance Paid",
    ADVANCE_PAID_ID: "advancePaid",
    REMAINING: "Remaining",
    REMAINING_ID: "remaining",
    ITEM_TOTAL: "Item Total",
    CONVENIENCE_FEE: "Convenience Fee",
    OFFER_AND_DISCOUNT: "Offers & Discount",
};

export const AMOUNT_FORMAT = "₹{0}";

export const CASHBACK_CALLOUT = "*{0}";

export const CART_BILL_ENTRY_ONE_LOGO_STYLE = {
    DEFAULT: {
        width: 16,
        height: 16,
    },
};

export enum DealCategory {
    BAU = "Pre-Book",
    GIRF = "GIRF",
    RESERVATION = "RESERVATION",
    EVENTS = "EVENTS",
    PREBOOK_POS = "Prebook_Pos", // proxy created category
    RESERVATION_POS = "RESERVATION_POS", // proxy created category
    EVENTS_POST_PAYMENT = "EVENTS_POST_PAYMENT",
    PREBOOK_PREPAID = "Prebook-Prepaid",
    PREBOOK_PREPAID_REDEEM = "Prebook_Prepaid_Redeem",
    PRIME_SLOT = "PrimeSlot",
}

export const DEAL_CATEGORY_SUB_PAGE: { [key: string]: string } = {
    [DealCategory.RESERVATION]: "DINEOUT_RESERVATION",
    [DealCategory.RESERVATION_POS]: "DINEOUT_RESERVATION_POS",
    [DealCategory.EVENTS]: "DINEOUT_EVENTS",
    [DealCategory.EVENTS_POST_PAYMENT]: "DINEOUT_EVENTS_POST_PAYMENT",
    [DealCategory.PREBOOK_PREPAID]: "PREBOOK_PREPAID_BOOKED",
    [DealCategory.PREBOOK_PREPAID_REDEEM]: "PREBOOK_PREPAID_REDEEMED",
    [DealCategory.PRIME_SLOT]: "DINEOUT_COMBINED_DEALS_PRIME",
    [DealCategory.PREBOOK_POS]: "DINEOUT_PREBOOK_POS",
};

export const INR_CURRENCY_SYMBOL_TEXT = "\u20B9{0}";

export const WEB_VIEW_URL = "swiggy://webviewV2?webview_url={0}";

export const PAYMENT_WEBVIEW_URL =
    "swiggy://webviewV2?payment_plugin=true&is_fullscreen=true&pushScreen=true&webview_url={0}";
export const SCENES_FULL_PAYMENT_REDIR_URL =
    "{0}/?flow=dineoutcart&state=SCENES_FULL_PAYMENT&darkTheme=true&orderId={1}";
export const SCENES_FULL_PAYMENT_REDIR_WEB_URL =
    "{0}/static-web-do-event-booking-cart/?flow=dineoutcart&state=SCENES_FULL_PAYMENT&darkTheme=true&orderId={1}";

export const X_WEB_CHECKOUT_FLOW_DINEOUT_CART = "dineoutcart";

export const ANALYTICS_CONSTANTS = {
    DONE: "done",
    CLOSE: "close",
};

export const HOMEPAGE_DEEPLINK = "swiggydiners://home";
export const DINEOUT_HOMEPAGE_WITH_REFRESH_DEEPLINK = "swiggydiners://home?reloadHome=true";
export const EVENTS_HOMEPAGE_DEEPLINK = "swiggydiners://events_home?reloadHome=true";
export const RESTAURANT_DEEPLINK = "swiggydiners://details/{0}";
export const EDP_DEEPLINK = "https://r.swiggy.com/v1/swiggy/scenes/comms/{0}";

export const DEEPLINK_BASE_URL = "https://swiggy.onelink.me/BVRZ?af_dp=";

export const WITH_OFFER = " with offer {0}";

export const animationTimeout = {
    default: 6500,
    savingsTime: 3500,
};

export const defaultTimeout = 2000;

export const DO_HELP_WEBVIEW_DEFAULT_URL = "https://www.swiggy.com/support/dineout-issues";

export const DO_EVENT_RESERVATION_HELP_WEBVIEW_URL = "https://www.swiggy.com/support/issues/swiggy_scenes_faq";

export const DO_STEALSTORE_RESERVATION_HELP_WEBVIEW_URL = "https://www.swiggy.com/support/issues/dineout_steal_deal";

export const CLEVERTAP_KEYS = {
    PAGE_VIEWED_EVENT: "Diners_payment_success_webview",
    RID: "r_id",
    TOTAL_BILL_AMOUNT: "total_bill_amount",
    COUPON_DISCOUNT: "coupon_discount",
    RESTAURANT_DISCOUNT: "restaurant_discount",
    RESTAURANT_NAME: "restaurant_name",
    ONE_DISCOUNT: "one_discount",
    BANK_OFFER: "bank_offer",
    SUM_OF_ALL_DISCOUNT: "sum_of_all_discount",
    DINEOUT_BOOKING_CONFIRM: "dineout_booking_confirm",
    DINEOUT_GIRF_DEAL_PURCHASE: "Dineout_GIRF_Deal_Purchase",
    BOOKED_DEAL_SHARE_CLICK: "Booked_Deal_Share_Click",
};

export enum COUPON_TYPE {
    FLAT = "FLAT",
    PERCENT = "PERCENT",
    STORE_DISCOUNT = "StoreDiscount",
}

export const CAROUSEL_DIMENTIONS = {
    height: 85,
    width: 320,
    itemWidth: "auto", //"max-content"
    ImageWidthvw: "91.7vw", // to change the each item width in the carousel
    ImageHeight: "auto",
};

export const CAROUSEL_TIMINGS = {
    scrollTime: 3000,
    autoScrollDelay: 3000,
};

export const tipBgImage = "dineout/bottom_sheet_header.png";

export const minTipAmount = 1;
export const maxTipAmount = 500;

export const TIP_TITLE = "Enter Tip Amount";
export const CUSTOM_TIP = "Add custom tip 🙌";
export const CONFIRM = "Confirm";
export const TIP_WARNING = "value should be in range between";

export const TEXT_TYPOGRAPHY = {
    BODY_B2_BOLD: "body_B2_Bold",
    TEXT_HIGH_EMPHASIS: "text_High_Emphasis",
    BODY_B2_MED: "body_B2_Med",
    POSITIVE: "positive",
    BODY_B3_REG: "body_B3_Reg",
    TEXT_MED_EMPHASIS: "text_Med_Emphasis",
};
export const LIST_TITLES = {
    TNC: "Offer terms & conditions",
    TTR: "Things to remember",
};

export const APP_BANNER_PROPS = {
    title: "Avail the offer by using Swiggy app",
    subTitle: "Pay the dining bill via Swiggy app, your offer gets auto applied!",
};

export const PAYMENT_TYPE = {
    GIRF_PAYMENT: "GIRF_PAYMENT",
};

const sacramentoFontPath = "https://media-assets.swiggy.com/dls-web-assets/dls/fonts";
export const SacramentoFont = createGlobalStyle`
@font-face {
    font-family: "Sacramento";
    font-weight: 400;
    font-display: block;
    src: url("${sacramentoFontPath}/Sacramento-Regular.woff2") format("woff2"),
        url("${sacramentoFontPath}/Sacramento-Regular.woff") format("woff"),
        url("${sacramentoFontPath}/Sacramento-Regular.ttf") format("truetype");
}
`;

export const REDEEM_TEXT = "Redeem it by paying bill via Swiggy";
const ONE_BENEFITS_CARD_INFO_DEFAULT_VALUE = {
    savingsValue: "",
    userStatus: false,
    oneLogoStyle: null,
    oneLogoUrl: "",
    successAnimationData: { bottomText1: "", bottomText2: "", bottomText3: "" },
    numericValue: 0,
    calloutInfo: {
        imageUrl: "",
        backgroundColor: "",
        borderColor: "",
    },
};

const BOOKING_DETAILS_DEFAULT = {
    day: "",
    date: "",
    slotGroupTitle: "",
    time: "",
    noOfGuests: 0,
    status: "",
};

const TICKET_ATTRIBUTES_DEFAULT = {
    offerDetails: {
        title: "",
        chipSrc: "",
        containerColorCode: "",
    },
    showDownloadCta: false,
    tnc: "",
    thingsToRemember: [],
};

export const DEFAULT_SUCCESS_DATA = {
    restaurantInfo: { restaurantName: "", restaurantAddress: "" },
    successBannerInfo: { totalAmount: "", paidAmount: "", tip: 0, subscriptionValue: 0, backgroundImage: "" },
    oneBenefitsCardInfo: ONE_BENEFITS_CARD_INFO_DEFAULT_VALUE,
    billDetailsInfo: [],
    paidImage: "",
    restaurantId: "",
    dealCategory: "",
    styles: {},
    bookingDetails: BOOKING_DETAILS_DEFAULT,
    ticketAttributes: TICKET_ATTRIBUTES_DEFAULT,
    savingCards: {
        title: "",
        cards: [],
    },
};

export const LIST_ITEM_PADDING = {
    top: "12px",
    bottom: "12px",
    left: 0,
    right: 0,
};

export const GOT_IT = "Got it";

export const EVENTS_POST_PAYMENT = "EVENTS_POST_PAYMENT";

export const DEVICE_DIMENSIONS = {
    DESKTOP_MIN: "1024px",
    TABLET_MAX: "1023px",
};

export const EVENT_BOOKING_SHARE_TITLE = "Swiggy Scenes";
export const DEAL_BOOKING_SHARE_TITLE = "Swiggy Dineout";

export const EVENT_BOOKING_SHARE_TEXT =
    "Hey! 🎉 \n Guess where I'll be on {0}? \n I’m all set for an epic event {1} that I booked on Swiggy Scenes! 🎉 \n\n It’s going down at {2}, {3} — and trust me, it’s going to be one for the books! It’s gonna be a blast, but it definitely won’t be the same without you!\n\n Wanna join? Grab your ticket now! 🎟️ \n {4}\n\n Follow @scenesonswiggy (https://www.instagram.com/scenesonswiggy) on Instagram for all the latest event updates ✨";

export const TABLE_BOOKING_SHARE_TEXT =
    "Hey!\nI have made a booking on {0}, {1} for {2} guest(s) at {3}, {4}{5}.\nPlease reach on time for a seamless experience and don't forget to pay your restaurant bill via Swiggy Dineout to get the best exclusive restaurant & payment offers on dining day.\nCheckout the restaurant details here: {6}";

export const WHAT_TO_DO_NEXT_DATA = {
    Title: "What to do next?",
    Points: {
        FullPayment: {
            One: "Please arrive at the venue on time for a seamless experience.",
            Two: "Show the QR code or share booking ID at the venue.",
        },
        PartialPayment: {
            One: "Pay the remaining amount before due date to confirm your booking.",
        },
    },
};

export const VIEW_VENUE_DETAILS = "View venue details";
export const VIEW_RESTAURANT_DETAILS = "View restaurant details";

export const RUSH_HOUR_TEXT_BANNER = "dineout/rushhourtextbanner.png";

export const CANCEL_BOOKING_TEXTS = {
    MAIN_TEXT: "Can't make it to the restaurant?",
    BUTTON_TEXT: "Cancel booking",
    POPUP_TEXT: "Are you sure you want to cancel this booking?",
    POPUP_GO_AHEAD_TEXT: "Yes, cancel",
    POPUP_GO_BACK_TEXT: "Don't cancel",
    POPUP_WIDTH: "85%",
};

export const CANCEL_BOOKING_CTA_ANALYTICS_FLAGS = {
    CANCEL_BOOKING: "yes",
    DONE_CANCEL_BOOKING: "no",
};

export const OOPS_SOMETHING_WENT_WRONG = "Oops Something went wrong!";

export const WIDGET_TYPES = {
    GRID_WIDGET: "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
    TEXT_BANNER: "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBanner",
    TEXT_BANNER_V2: "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBannerV2",
    IMAGE_INFO_LAYOUT_CARD: "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
    DEALS_INFO_WIDGET: "type.googleapis.com/swiggy.presentation.dinersone.v1.DealsInfo",
    CTA_LIST: "type.googleapis.com/swiggy.presentation.dinersone.v1.CtaList",
    DEAL_BOOKED_SUCCESS_BANNER: "type.googleapis.com/swiggy.presentation.dinersone.v1.DealBookedSuccessBanner",
};

export const TEXT_BANNER_DISPLAY_TYPE = {
    DINEOUT_CHARGE_CALLOUT: "TEXT_BANNER_DISPLAY_TYPE_DINEOUT_CHARGE_CALLOUT",
    DINEOUT_CANCEL_RESERVATION: "TEXT_BANNER_DISPLAY_TYPE_DINEOUT_CANCEL_RESERVATION",
};

export const ALLOWED_DEAL_CATEGORIES_FOR_SHARE = [
    DealCategory.BAU,
    DealCategory.GIRF,
    DealCategory.RESERVATION,
    DealCategory.PRIME_SLOT,
    DealCategory.EVENTS_POST_PAYMENT,
    DealCategory.EVENTS,
];

export const FETCHING_BOOKING_DETAILS = "Fetching booking details";

export const LOCATION_URLS = {
    IOS: "http://maps.apple.com/?q={0}&ll={1},{2}",
    ANDROID: "geo:{1},{2}?q={1},{2}({0})",
    WEB: "https://www.google.com/maps/search/?api=1&query={1},{2}",
};

export const CALL_URL = "tel:{0}";

export const ONE_LOGO_TEXT = "one-logo";
export const MULTIPLE_CARD_HEIGHT = "190px";
export const SINGLE_CARD_HEIGHT = "140px";
export const MULTIPLE_CARD_WIDTH = "50%";
export const SINGLE_CARD_WIDTH = "100%";

export const STATUS_BAR_COLOR_DEFAULT = "#ffffff";
export const STATUS_BAR_COLOR_DARK = "#000000";

// Dating flow constants
export const DATING_DEEPLINK_PREFIX = "swiggy://fusion-landing?id={0}";
